import dayjs                from 'dayjs';
import EditDemandTableCell  from './EditDemandTableCell';

const EditDemandTable = ({demandPostData, onChangeValue, newValues}) => {

    const { demandPostColumns, demandPostLines } = demandPostData || {};

    return (
        
        <>

            <table className="w-full table-fixed rounded-[8px] [border-spacing:0] border-separate border">
                                                
                <thead className=" bg-neutro ">
                    
                    <tr>

                        <th className='font-small text-[small] p-[0.5rem] border-b-[1px_solid_#e3e2e2] text-center'>Terminal</th>
                        <th className='font-small text-[small] p-[0.5rem] border-b-[1px_solid_#e3e2e2] text-center'>Produto</th>
                        
                        {demandPostColumns?.map((demandPostColumn, index) => (
                            
                            <th 
                                className={
                                    `font-small 
                                    text-[small] 
                                    p-[0.5rem] 
                                    border-b-[1px_solid_#e3e2e2] 
                                    text-center ${index === demandPostColumns.length - 1 ? 'rounded-tr-[8px]' : ''}`
                                } 
                                key={index}
                            >	
                                <div 
                                    className='flex flex-col'
                                >
                                    <span className='text-[small]'>
                                        {demandPostColumn.name}
                                    </span>
                                    
                                    <span className='text-[x-small] text-gray-600'>
                                    {
                                        dayjs(
                                            demandPostColumn.date
                                        ).format(
                                            demandPostColumn.ownerDemandPost.ownerDemandHorizon.ownerHorizonOfPlan.columnsFo
                                        )
                                    }
                                    </span>	

                                    
                                </div>
                            </th>
                        ))}


                    </tr>	

                </thead>

                <tbody>

                    {demandPostLines?.map((demandPostLine, index) => (
                        
                        <tr key={index}>

                            <td className="text-[smaller] border text-sm text-left px-2">{demandPostLine.ownerTerminal.name}</td>
                            <td className="text-[smaller] border text-sm text-left px-2">{demandPostLine.ownerProduct.name}</td>

                            {demandPostColumns.map((demandPostColumn, colIndex) => (
                                
                                
                                <td 
                                    key={`${demandPostLine.id}-${colIndex}`} 
                                    className="
                                        text-[smaller]
                                        border
                                        text-sm
                                        text-right
                                        px-2
                                        overflow-hidden
                                    "
                                >
                                    <EditDemandTableCell 
                                        demandValue={demandPostLine.demands.find(demand => demand.demandPostColumnId === demandPostColumn.id)} 
                                        onChangeValue={(id, value) => onChangeValue(id, value)}
                                        newValue={newValues.find(item => item.id === demandPostLine.demands.find(demand => demand.demandPostColumnId === demandPostColumn.id)?.id)?.newValue}
                                    />
                                    
                                
                                </td>
                            ))}

                            

                        </tr>
                    ))}

                </tbody>

            </table>

        </>
        
    )
}

export default EditDemandTable;